export default __webpack_public_path__ + "static/media/hong_kong_banner.6e99ab1f.jpg";